<div>
  <mat-progress-bar
    *ngIf="loading.loadingSub() || manualLoading; else gap"
    mode="query"
    [themeColor]="'loading-bar'"
  ></mat-progress-bar>
  <ng-template #gap>
    <div class="gap"></div>
  </ng-template>
</div>
